import { CaseListItem } from 'queries/cases/types';
import React from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { EllipsisTextWithTooltip } from '@shape-ds/components';

interface PdfCasesSummaryItemProps {
  caseItem: CaseListItem;
}
const CASE_ITEM_FIELDS = ['name', 'severity', 'discipline', 'status'] as Array<
  keyof Omit<CaseListItem, 'asset' | 'actions' | 'children' | 'external_reference_summary'>
>;

const PdfCasesSummaryItem: React.FC<PdfCasesSummaryItemProps> = ({ caseItem }) => {
  const { t } = useTranslation();
  return (
    <div className={`pdf-cases-summary-line pdf-cases-summary-line-${caseItem.severity}`}>
      {CASE_ITEM_FIELDS.map((field) => (
        <span
          className={`pdf-cases-summary-cell pdf-cases-summary-cell-${field}`}
          style={{ gridArea: field }}
        >
          <EllipsisTextWithTooltip
            text={t(`pdf:${field}.${caseItem[field]}`, { defaultValue: caseItem[field] })}
            rows={2}
          />
        </span>
      ))}
    </div>
  );
};

export default PdfCasesSummaryItem;
